import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    errorMessage:
      'An error occurred while sending your invoice. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    send: 'Send',
    sendDummyInvoiceError:
      'An error occurred while sending the test email. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    sendDummyInvoiceSuccess: 'Test email sent!',
    sendToMyself: 'Send myself a test email',
    successMessage: 'Your invoice was sent to your client by email',
    title: 'Send invoice',
  },
  fr: {
    errorMessage:
      'Une erreur est survenue lors de l’envoi de votre facture. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    send: 'Envoyer',
    sendDummyInvoiceError:
      'Une erreur est survenue lors de l’envoi de l’e-mail de test. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    sendDummyInvoiceSuccess: 'E-mail de test envoyé\xA0!',
    sendToMyself: 'M’envoyer un e-mail test',
    successMessage: 'Votre facture a été envoyée à votre client par e-mail',
    title: 'Envoyer ma facture',
  },
} as const);
